import { render } from "./PageFlip.vue?vue&type=template&id=97c70b66&scoped=true"
import script from "./PageFlip.vue?vue&type=script&lang=js"
export * from "./PageFlip.vue?vue&type=script&lang=js"

import "./PageFlip.vue?vue&type=style&index=0&id=97c70b66&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97c70b66"]])

export default __exports__